export default __webpack_public_path__ + "assets/eye.4b0e5d75.svg";